<template>
  <div id="headerBox" >
    <!-- <div  id="headerTop">
      <div class="flex_sb wrapWidth">
        <div>{{date}}</div>
        <div>
          <span @click="changeLan('CN')" style='cursor: pointer;margin-right: 1.9rem;'>简体中文</span>
          <span @click="changeLan('CNTW')" style='cursor: pointer;margin-right: 1.9rem;'>繁体中文</span>
          <span @click="changeLan('EN')" style='cursor: pointer;'>English</span>
        </div>
      </div>
    </div> -->
    <div id="titleBox" class="flex_sb wrapWidth pc">
      <div class="flex_sb">
        <img src="@/../static/images/login/title_CNTW.png" v-if="globalVar.lang=='CNTW'" alt="" srcset="" @click="$router.go()" style="cursor:pointer">
        <img src="@/../static/images/login/title@2x.png" v-else alt="" srcset="" @click="$router.go()" style="cursor:pointer">

        <div id="dateBox">
          <!-- <p style="margin-bottom: 0.5rem;">距第{{data.year}}届开幕</p> -->
          <p>距第二十二届开幕</p>
          <p>还有<span style="font-size: 2.4rem;color:#EA0E1EFF;font-weight: bold;">{{data.days}}</span>天</p>
        </div>
      </div>
      <div id="personal" class="flex_sb" >
        <div v-if="login && $route.name!='login'">
          <!-- <mbtn style="margin-right:2rem" name='个人中心' red round @click="go('personal')" ></mbtn> -->
        </div>
        <div class="flex_sb" v-else>
          <!-- {{login}}00 -->
          <mbtn name='注册' style="margin-right:2rem" white round @click="go('register')" ></mbtn>
          <mbtn style="margin-right:2rem" name='登录' red round @click="go('login')" ></mbtn>
        </div>
      </div>
    </div>
    <div id="phoneHeader" class="phone">
      <div class="flex_sb">
       
        <img src="@/../static/images/login/title_CNTW.png" v-if="globalVar.lang=='CNTW'" alt="" srcset="" @click="changeLan('CNTW')" style="cursor:pointer">
        <img src="@/../static/images/login/title@2x.png"  v-else alt="" srcset="" @click="changeLan('CN')" style="cursor:pointer">
        <div style="display: flex;align-items: center;touch-action:none;">
          <el-popover
            placement="bottom"
            width="100"
            popper-class='elpp'
            trigger="click">
            <ul>
              <li style="margin-bottom:10px" @click="changeLan('CN')">简体中文</li>
              <li style="margin-bottom:10px" @click="changeLan('CNTW')">繁体中文</li>
              <li style="margin-bottom:0px" @click="changeLan('EN')">English</li>
            </ul>
            <span slot="reference">{{nowLanguage}}&ensp;<span class="iconfont icon-down" style="font-size: 0.7rem;color:#BFBFBFFF"></span></span>
          </el-popover>


          <span class="iconfont icon-me" v-if="true" 
          style="font-size: 2.1rem;color:#333333FF;margin-left:1.7rem" @click="showMenu=!showMenu;menuType='personal'"></span>
          
          <span class="iconfont icon-menu" style="font-size: 1.4rem;color:#333333FF;margin-left:1.7rem"   @click="showMenu=!showMenu;menuType='menu'"></span>
        </div>
      </div>
      <!-- //手机端菜单栏 -->
      <div id='phoneMenu' :style="{maxHeight:showMenu?'100vh':'0vh'}" v-show="showMenu">
        <ul v-if="menuType=='personal' && login">
          <li :class="[$route.name=='personal'?'active':null]" @click="changePage('personal')">个人中心</li>
          <li @click="exit">注销</li>
         
        </ul>
        <ul v-else-if="menuType=='personal' && !login">
          
          <li :class="[$route.name=='login'?'active':null]" @click="go('login')">登录</li>
          <li :class="[$route.name=='register'?'active':null]" @click="go('register')">注册</li>

         
        </ul>
         <ul v-else-if="menuType=='menu'">
          <!-- <li :class="[$route.name=='room'?'active':null]" @click="changePage('room')">创建洽谈</li> -->
          <li  :class="{'active': $route.path.indexOf(item.link) !== -1}"  v-for="(item,index) in globalmenu.menu" :key="index" :value="item.name" @click="changePage(item)">{{item.name}}</li>
        </ul>
        <!-- //遮罩层 -->
        <div class="dark" @click="showMenu=!showMenu"></div>
      </div>
    </div>




  </div>
        

    
 
</template>
<script>
// 导入组件
// import { menu } from '@/api/userMG'
import {getSession,setSession,getCookie,setCookie,delCookie} from '@/util/util'
import mbtn from '@/components/btn'
import { detail} from '@/api/login'
import { Notification } from 'uiv'


export default {
  name: 'index',
  // 注册组件
  components: {
    mbtn
  },
  props:{
    data:Object
  },
  data() {
    return {
      date:null,
      // data:Object,
      login:false,
      showMenu:false,//手机端菜单弹窗
      menuType:"menu",
    }
  },
  watch:{
    "$route.name"(a){
      console.log('changeUrl,checkLogin')
      this.checkLogin()
    }
  },
  computed:{
    nowLanguage(){
      if(this.globalVar.lang=='CNTW') 
      {
        return '繁体中文'
      }
      else
      {
        // console.log(this.globalVar.lang)
        return '简体中文'
      }
    }
  },
  methods: {
    changePage(item){//移动一级菜单
      // console.log(item)
      if(item.name == '国际投资论坛')
      {
        window.open('https://www.chinafair.org.cn/iiforum/#/')
      }
      else
      {
        this.$router.push({path: item.link})
        this.showMenu = false;
      }
      
    },
    changeLan(la){
      // setSession('language',la)
      // this.$i18n.locale=la
      // this.changeDate()
      // this.$store.state.language=la
      switch (la) {
        case "CN":
            window.location.href = this.globalVar.imgUrl+"/CifitSystem/china/#/index";
            break;
        case "CNTW":
            window.location.href = this.globalVar.imgUrl+"/CifitSystem/chinatw/#/index";
            break;
        case "EN":
            window.location.href = this.globalVar.imgUrl+"/CifitSystem/english/#/index";
            break;
        case "FR":
            window.location.href = this.globalVar.imgUrl+"/CifitSystem/french/#/index";
            break;
        case "JA":
            window.location.href = this.globalVar.imgUrl+"/CifitSystem/japanese/#/index";
            break;
        case "KO":
            window.location.href = this.globalVar.imgUrl+"/CifitSystem/korean/#/index";
            break;
        case "ES":
            window.location.href = this.globalVar.imgUrl+"/CifitSystem/spanish/#/index";
            break;
        case "AR":
            window.location.href = this.globalVar.imgUrl+"/CifitSystem/arabic/#/index";
            break;
      }
    },
    exit(){
      delCookie('token')
      this.$store.commit('setUser',{})
      this.$router.push({path:this.$route.path,query:{
        // token:null
      }})
      if(this.$store.state.language=='EN')
      {
        
      }
      else
      {
        
      }
    
      this.checkLogin()
      
    },
    go(name){
      // window.open(this.globalVar.cifitWeb+name)
      console.log(1,this.globalVar.cifitWeb+name)
      // return
      window.location.href=this.globalVar.cifitWeb+name+'?language='+this.globalVar.lang
    },
    checkLogin(){
      const token =  this.$route.query.token
      console.log(token)
      //  console.log(123456,getCookie('token'))
      
      if(token)
      {
        setCookie('token',token)
        
        this.detail()
        
      }
      else if(getCookie('token'))
      {
        
        this.detail()
        
      }
      else
      {
        this.login=false
      }
    },
    changeDate(){
      var moment = require('moment');
      let lan;
      let se =getSession('language') 
      
      if(se=='EN')
      {
        lan='en'
      }
      else if(se=='CNTW')
      {
        lan='zh-tw'
      }
      else
      {
        lan='zh-cn'
      }
      moment.locale(lan);
      this.date = moment().format('LLLL')
    },
    // changeLan(la){
    //   setSession('language',la)
    //   this.$i18n.locale=la
    //   // this.changeDate()
    //   this.$store.state.language=la
    // },
    detail(){
      
      this.loadUserInfo=true
      detail().then(({code,data,msg})=>{
         this.loadUserInfo=false
        if(code==100){
          // this.userData=data
          this.$store.commit('setUser',data)
          console.log(this.$store.state)
          this.login=true
        
        }
        else
        {
 
        }
      }).catch(res=>{
        this.loadUserInfo=false
        console.log(res)});
    }
  },
  created() {
    this.checkLogin()
    // this.changeDate()
    // dateinfo().then(({code,data,msg})=>{
    //   if(code==200){
    //     this.data=data
    //   }
    //   else
    //   {
    //     this.$emsg(msg)
    //   }
    // })
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    
  }
}
</script>
<style lang="less" scoped>
.flex_sb
{
  display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}
#headerBox
{
 
  font-size: 1rem;
  font-weight: 400;
  color: #595959;
  
}
#headerTop
{
  padding: 1rem;
  margin: auto;
  border-bottom: 1px solid #D8D8D8FF;
}
#titleBox
{
  margin:auto;
  display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  &>#dateBox
  {
    background: #FFFFFF;
    border: 1px solid #E3E3E3;
    border-radius: 6px;
    padding: 1.7rem;
    font-size: 1.4rem;
    font-weight: 500;
    color: #333333;
    margin-left: 4.6rem;

  }
  &>div
  {
    // margin: 1.5rem 0;
    
  }
  & img
  {
    width: 80%;
     width: 467px;
    max-width: 100%;
    margin-right: 4.6rem;
  }
  & #dateBox
  {
    text-align: center;
    background: #FFFFFF;
    border: 1px solid #E3E3E3;
    border-radius: 0.6rem;
    font-size: 1.4rem;
    font-weight: 500;
    color: #333333;
    padding: 1.7rem;
  }
}
.pc
{
  
}
.phone
{
  display: none !important;
}
@media screen and (max-width:1040px){
  .pc
  {
    display: none !important;
  }
  .phone
  {
    display: block !important;
  }
}

#phoneHeader
{
  img{
    width: 50%;
  }
  // height: 10rem;
  // padding: 0.8rem;
    display: flex ;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
    margin: auto;
  .changeLangage
  {
    // background-color: #E8E8E8FF;
    border-radius: 2rem;
    // padding: 0.4rem 2.2rem;
  }
}
@media screen and (max-width:1040px){
    #headerBox
    {
        border-bottom: 1px solid #D8D8D8;
    }
}
#phoneMenu
{
  z-index: 5;
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translate(0%,100%);
  width: 100%;
  max-height: 0%;
  transition: max-height 1s;
  // overflow: hidden;
  li{
    background-color: #fff;
    
    padding: 0rem 2rem;
    border-top: 0.1rem solid #e4e4e4;
    font-size: 1.5rem;
    text-align: left;
    color: #333;
    &:last-of-type
    {
      border-bottom: 0.1rem solid #e4e4e4;

    }
  }
  .active
  {
    background-color: #ff4e4e;
    color: #fff;
  }
  
}
.showMenu
  {
    max-height: 100vh !important;
  }
.dark
{
  position: fixed;
  color: black;
  width: 100vh;
  height: 100vh;
  background-color: black;
  z-index: -1;  //父级Z-INDEX  -1
  opacity: 0.4;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

}
</style>
<style>
.elpp
{
  min-width: unset !important;
}
</style>





// WEBPACK FOOTER //
// src/components/HeaderNav/HeaderNav.vue